import React from 'react';
import { Stack,Text } from '@fluentui/react';
import { useFluentTheme } from '@theme/index';
import image1 from 'assets/logo.svg';
import image2 from 'assets/secondaryLogo.svg';
import { NavBar, SignUp } from 'atoms/index';
import Footer from 'atoms/Footer';

import getStyles from './HomePage.styles';

export const HomePage = () => {
  const theme = useFluentTheme();
  const { mainWrapper, logoSection } = getStyles(theme);
  return (
    <Stack>
      <Stack
        styles={mainWrapper}
        tokens={{ childrenGap: 40 }}
        horizontalAlign='center'
        verticalAlign='center'
      >
        <Stack styles={logoSection} horizontal verticalAlign='center' horizontalAlign='center'>
          <Stack.Item>
            <img width='100%' height='100%' src={image1} alt='logo' />
          </Stack.Item>
          <Stack.Item>
            <img width='100%' height='100%' src={image2} alt='secondary-logo' />
          </Stack.Item>
        </Stack>
        <Text variant='xLarge'>Video Visits made Unburden some</Text>
        <SignUp />
        {/* <AboutUs /> */}
        {/* <Reviews /> */}
        {/* <NewsLetter /> */}
        <NavBar />
      </Stack>
      <Footer />
    </Stack>
  );
};
